import "../../css/layout/footer.css"

function Footer({login}) {
    return (
        <footer>
            <p className="copyright">© 2026 Skoleo par <strong>Scorgister</strong>. Tous droits réservés.</p>
        </footer>
    );
}

export default Footer;